







































































import AuthorizationService from "@/app/service/authorization";
import Countdown from "@/components/countdown";
import IApiError from "@/app/model/IApiError";
import KeyResult from "@/app/model/KeyResult";
import OtpData from "@/app/model/OtpData";
import PasswordService from "@/app/service/password";
import ProcessResultKey from "@/app/dto/ProcessResultKeyEnum";
import RouteName from "@/app/router/NameEnum";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { RequiredValidator } from "@hc-hefaistos/hc-components";
import OtpResult from "@/app/model/OtpResult";

@Component({
    components: {
        Countdown
    }
})
export default class Otp extends Vue {
    @Prop({ type: String }) customerUuid!: string;
    @Prop({ type: String }) password!: string;

    private keyResult: KeyResult | null = null;
    private phoneNumber: string = "";
    private waiting: boolean = false;
    private otpValue: string = "";
    private otpValidator: RequiredValidator = new RequiredValidator(this.$localize("sms.required"));
    private smsInvalid: boolean = false;
    private otpErrors = [ProcessResultKey.OTP_LIMIT_REACHED, ProcessResultKey.OTP_NOT_READY_YET, ProcessResultKey.OTP_PHONE_BLOCKED];

    private get getWaitUntilBlockId(): string {
        return this.isBlockedWaitUntil ? "withBlockUntil" : "withWaitUntil";
    }

    private get isBlockedWaitUntil(): boolean {
        return this.isNotReadyYet || this.isLimitReached || this.isPhoneBlocked || this.isAuthorizationBlocked;
    }

    private get getBlockedWaitUntilReason(): string {
        let reasonTranslationKey: string = "";
        if (this.isNotReadyYet) {
            reasonTranslationKey = "sms.not_ready_yet";
        } else if (this.isLimitReached) {
            reasonTranslationKey = "sms.too_many_attempts";
        } else if (this.isPhoneBlocked) {
            reasonTranslationKey = "sms.phone_blocked";
        } else if (this.isAuthorizationBlocked) {
            reasonTranslationKey = "sms.authorization_blocked";
        }

        return this.$localize(reasonTranslationKey);
    }

    private get isNotReadyYet(): boolean {
        return !!this.keyResult?.isNotReadyYet();
    }

    private get isLimitReached(): boolean {
        return !!this.keyResult?.isLimitReached();
    }

    private get isPhoneBlocked(): boolean {
        return !!this.keyResult?.isPhoneBlocked();
    }

    private get isAuthorizationBlocked(): boolean {
        return !!this.keyResult?.isAuthorizationBlocked();
    }

    private get isValid(): boolean {
        return this.otpValidator.validate(this.otpValue);
    }

    private onCountdownEnd(): void {
        this.waiting = false;
    }

    private onSubmit(): void {
        this.clearErrors();
        if (this.isValid) {
            PasswordService.setPassword(
                this.password,
                this.customerUuid,
                new OtpData(this.otpValue, this.keyResult?.getOtpKey() || ""),
                this.keyResult?.getAuthorizationKey() || ""
            )
                .then(() => {
                    this.$router.push({ name: RouteName.RESULT });
                })
                .catch((error: IApiError) => {
                    this.processSetPasswordError(error);
                });
        }
    }

    private createKeyRequest(sendOtp: boolean): void {
        AuthorizationService.authorizationKey(this.customerUuid, sendOtp)
            .then((response: KeyResult) => {
                if (this.keyResult) {
                    this.keyResult?.mergeKey(response);
                } else {
                    this.keyResult = response;
                }
                this.processKeyResult();
            })
            .catch((error: IApiError) => {
                this.routeToError();
            });
    }

    private sendOtpRequest(): void {
        if (this.keyResult?.authKey) {
            AuthorizationService.sendOtp(this.customerUuid, this.keyResult?.getAuthorizationKey() || "")
                .then((response: OtpResult) => {
                    this.keyResult?.mergeOtp(response);
                    this.processKeyResult();
                })
                .catch((error: IApiError) => {
                    this.routeToError();
                });
        } else {
            this.createKeyRequest(true)
        }
    }

    private processKeyResult(): void {
        if (!!this.keyResult?.authKey || this.otpErrors.includes(this.keyResult?.error?.status as ProcessResultKey)) {
            this.setupPhone();
            this.setupInitWaiting();
        } else if (this.keyResult?.isVerifiedMobileNotFound()) {
            this.$router.push({ name: RouteName.VERIFY_PHONE });
        } else {
            !!this.keyResult?.error ? this.processKeyError(this.keyResult?.error) : this.routeToError();
        }
    }

    private setupPhone(): void {
        if (!!this.keyResult?.getPhoneNumber()) {
            this.phoneNumber = this.keyResult?.getPhoneNumber() || "";
        }
    }

    private setupInitWaiting(): void {
        let waitUntil: Date | undefined = this.keyResult?.getWaitUntil();
        this.waiting = !!waitUntil && waitUntil > new Date();
    }

    private processKeyError(error: IApiError): void {
        let errorHeading: string = "";
        let errorMessage: string = "";

        switch (error.status) {
            case ProcessResultKey.ACCOUNT_BLOCKED:
                errorHeading = this.$localize("error.account.title");
                errorMessage = this.$localize("error.account.blocked.message");
                break;
            case ProcessResultKey.AUTHORIZATION_BLOCKED:
                errorHeading = this.$localize("error.account.title");
                errorMessage = this.$localize("error.authorization.blocked.message");
                break;
        }

        this.routeToError({ heading: errorHeading, message: errorMessage });
    }

    private processSetPasswordError(error: IApiError): void {
        if (error.status == ProcessResultKey.AUTHORIZATION_INVALID) {
            this.createKeyRequest(false);
            this.smsInvalid = true;
        } else {
            this.routeToError();
        }
    }

    private clearErrors(): void {
        this.smsInvalid = false;
    }

    private routeToPhone(): void {
        this.$router.push({ name: RouteName.PHONE });
    }

    private routeToError(params?: { heading: string; message: string }) {
        this.$router.push({ name: RouteName.ERROR, params });
    }

    created() {
        this.createKeyRequest(true);
    }
}
